// 子仓库-产品管理
import to from 'await-to-js';
import * as apis from "@/api/interface/pm";
import {copy} from '@/utils/base';

export default {
  namespaced: true,
  state: () => ({
    zxRateList: undefined,  //赠险费率-列表
    zxRateInsuranceCompanyOptions: undefined,  //赠险费率-选项列表-保司
  }),
  getters: {},
  mutations: {
    update(state, payload) {
      Object.keys(payload).forEach((key) => {
        state[key] = payload[key];
      });
    },
    updateZxRateListBySingle(state, payload) {
      const {index, row} = payload;
      const zxRateList = copy(state.zxRateList);
      const {list} = zxRateList;
      list[index] = {...list[index], ...row};      
      state.zxRateList = zxRateList;
    },
  },
  actions: {
    // 赠险费率-选项列表-保司
    async getZxRateInsuranceCompanyOptions(ctx, payload = {}) {
      const [err, res] = await to (apis.getZxRateInsuranceCompanyOptions(payload));
      ctx.commit("update", {
        zxRateInsuranceCompanyOptions: !err && res.data ? res.data : undefined,
      });
    },
    // 赠险费率-选项列表-数据类型
    async getZxRateInsuranceDataTypeOptions(ctx, payload = {}) {
      const [, res] = await to (apis.getZxRateInsuranceDataTypeOptions(payload));
      return res;
    },
    // 赠险费率-选项列表-赠险CODE
    async getZxRateInsuranceCodeOptions(ctx, payload = {}) {
      const [, res] = await to (apis.getZxRateInsuranceCodeOptions(payload));
      return res;
    },
    // 赠险费率-列表
    async getZxRateList(ctx, payload = {}) {
      const [err, res] = await to (apis.getZxRateList(payload));
      ctx.commit("update", {
        zxRateList: !err && res.data ? res.data : undefined,
      });
    },
    // 赠险费率-添加、修改
    async zxRateAddOrUpdate(ctx, payload = {}) {
      const [, res] = await to(apis.zxRateAddOrUpdate(payload));
      return res;
    },
    // 赠险费率-状态修改
    async zxRateStatusChange(ctx, payload = {}) {
      const [, res] = await to(apis.zxRateStatusChange(payload));
      if (res && res.data){
        ctx.commit("updateZxRateListBySingle", {
          index: payload.index,
          row: {
            status: payload.status,
          },
        });
      }
      return res;
    },
    // 赠险费率-删除
    async zxRateDelete(ctx, payload = {}) {
      const [, res] = await to(apis.zxRateDelete(payload));
      return res;
    },

  },
  modules: {},
};
